module.exports = __webpack_public_path__ + "assets/allstar-d217fb6092030a17b35d22941ce29d98.svg";